import { Link } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
import img1 from "../../assets/logo/icons8-united-kingdom-48.png";
import img2 from "../../assets/logo/icons8-egypt-48.png";
import { useDispatch, useSelector } from "react-redux";
import { setLanguage } from "../../store/language/lanSlicer";
import { baseUrl } from "../../utils/APi";
import { getSocialMedia } from "../../store/contact/contactAction";
import logo from "../../assets/logo1.png";
const SideMenu = ({ sideMenu, handleSide }) => {
  return (
    <div className={`side-menu__block ${sideMenu ? "active" : ""}`}>
      <div className="side-menu__block-overlay custom-cursor__overlay"></div>
      <div className="side-menu__block-inner">
        <div className="side-menu__top justify-content-end">
          <button
            className="side-menu__toggler side-menu__close-btn"
            onClick={(e) => {
              e.preventDefault();
              handleSide();
            }}
          >
            <img src="assets/icon/close-1-1.png" alt="images" />
          </button>
        </div>
        <div className="side-menu__top-introduce">
          <a href="index.html" rel="home" className="main-logo">
            <img src={logo} alt="images" />
          </a>
          <p>
            Etiam efficitur, metus in cursus imperdiet, neque nisl porta erat,
            nec volutpat felis lacus a tellus. Nunc tristique nulla nisi, a
            viverra dui auctor vitae. Vestibulum mollis commodo leo in
            hendrerit. Nam convallis ac lacus luctus vestibulum. Donec cursus
            tellus id neque convallis blandit.
          </p>
          <hr />
        </div>
        <div className="side-menu__top-lastest">
          <div className="side-menu__title">My Latest Work</div>
          <div className="side-menu__lastest">
            <div className="side-menu__lastest-item">
              <img
                src="assets/images/image-box/side-menu-latest-1.jpg"
                alt="images"
              />
              <div className="side-menu__lastest-layer"></div>
            </div>
            <div className="side-menu__lastest-item">
              <img
                src="assets/images/image-box/side-menu-latest-2.jpg"
                alt="images"
              />
              <div className="side-menu__lastest-layer"></div>
            </div>
            <div className="side-menu__lastest-item">
              <img
                src="assets/images/image-box/side-menu-latest-3.jpg"
                alt="images"
              />
              <div className="side-menu__lastest-layer"></div>
            </div>
            <div className="side-menu__lastest-item">
              <img
                src="assets/images/image-box/side-menu-latest-4.jpg"
                alt="images"
              />
              <div className="side-menu__lastest-layer"></div>
            </div>
            <div className="side-menu__lastest-item">
              <img
                src="assets/images/image-box/side-menu-latest-5.jpg"
                alt="images"
              />
              <div className="side-menu__lastest-layer"></div>
            </div>
          </div>
          <hr />
        </div>
        <div className="side-menu__top-social">
          <ul className="widget-social">
            <li>Follow Me :</li>
            <li>
              <a href="#">
                <i className="fa-brands fa-facebook"></i>
              </a>
            </li>
            <li>
              <a href="#">
                <i className="fa-brands fa-linkedin"></i>
              </a>
            </li>
            <li>
              <a href="#">
                <i className="fa-brands fa-instagram"></i>
              </a>
            </li>
            <li>
              <a href="#">
                <i className="fa-brands fa-youtube"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SideMenu;
